import { render, staticRenderFns } from "./collect-analysis.vue?vue&type=template&id=04e9a62b&scoped=true&"
import script from "./collect-analysis.vue?vue&type=script&lang=ts&"
export * from "./collect-analysis.vue?vue&type=script&lang=ts&"
import style0 from "./collect-analysis.vue?vue&type=style&index=0&id=04e9a62b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e9a62b",
  null
  
)

export default component.exports